import { useMemo, useEffect } from 'react';
import useScreenSize from './useScreenSize';
import { Apartment } from '../graphql/graphql';
import { useClient } from './useClient';
import { usePagination } from './usePagination';

const ALL_FILTER_VALUE = 'all';

export const useApartmentsFilter = (
  currentFilter: string | number,
  apartmentsList: Apartment[] = []
) => {
  const { isSmallOrLargeDesktop } = useScreenSize();
  const isClient = useClient();

  const itemsPerPage = useMemo(() => {
    if (!isClient) return 6;
    return isSmallOrLargeDesktop ? 6 : 4;
  }, [isClient, isSmallOrLargeDesktop]);

  const filteredList = useMemo(() => {
    if (!apartmentsList.length) return [];

    return apartmentsList.filter(item => {
      if (currentFilter === ALL_FILTER_VALUE) return true;
      return item.rooms === currentFilter;
    });
  }, [apartmentsList, currentFilter]);

  const { paginatedData, currentPage, totalPages, goToPage, setCurrentPage } =
    usePagination({
      data: filteredList,
      itemsPerPage
    });

  useEffect(() => {
    setCurrentPage(1);
  }, [currentFilter, setCurrentPage, itemsPerPage]);

  return {
    filteredList,
    paginatedList: paginatedData,
    currentPage,
    totalPages,
    goToPage,
    setCurrentPage
  };
};
